import { render, staticRenderFns } from "./Opcoes.vue?vue&type=template&id=2a0746f8&"
import script from "./Opcoes.vue?vue&type=script&lang=js&"
export * from "./Opcoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports